import { createAccountInstance } from '../api-instance';

export {
  getApiV1Me as getMe,
  patchApiV1Me as patchMe,
} from './generate/account.gen';

export type LegalEntityType = 'ip' | 'ooo';

export interface LegalEntityResponse {
  entity_type: LegalEntityType | null;
  name: string | null;
  inn: string | null;
  kpp: string | null;
  ogrn: string | null;
  legal_address: string | null;
}

export interface UpsertLegalEntityRequest {
  entityType: LegalEntityType;
  name: string;
  inn: string;
  kpp?: string;
  ogrn?: string;
  legalAddress?: string;
}

export const getAccountLegalEntity = () =>
  createAccountInstance<LegalEntityResponse>({
    url: '/api/v1/account/legal-entity',
    method: 'GET',
  });

export const putAccountLegalEntity = (data: UpsertLegalEntityRequest) =>
  createAccountInstance<LegalEntityResponse>({
    url: '/api/v1/account/legal-entity',
    method: 'PUT',
    data,
  });

export type { IUserDto, IUserUpdateRequestDto } from './types';
